import React from 'react'
import useStyles from './GeneralPanelPage.styles'

interface IProps {
  children: React.ReactNode
  header?: React.ReactNode
}

export const GeneralPanelPage = ({ children, header }: IProps) => {
  const { classes } = useStyles()

  return (
    <div className={classes.wrap}>
      {header && <div className={classes.header}>{header}</div>}

      <div className={classes.main}>
        <div className={classes.content}>{children}</div>
      </div>
    </div>
  )
}
